import * as React from 'react'
import { SxProps, sx as sxFunc } from '../sx'
import { Collapse } from '../Collapse'
import { TransitionProps } from '../transitions'
import { StepperContextType, useStepperContext } from '../Stepper'
import { StepContextType, useStepContext } from '../Step/StepContext'
import clsx from 'clsx'
import style from './index.module.scss'

export interface StepContentClasses {
  /** Styles applied to the root element. */
  root: string
  /** Styles applied to the root element if `last={true}` (controlled by `Step`). */
  last: string
  /** Styles applied to the Transition component. */
  transition: string
}

export interface StepContentProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * The content of the component.
   */
  children?: React.ReactNode
  /**
   * Override or extend the styles applied to the component.
   */
  classes?: Partial<StepContentClasses>
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx?: SxProps
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Collapse
   */
  TransitionComponent?: React.JSXElementConstructor<
    TransitionProps & { children: React.ReactElement<any, any> }
  >
  /**
   * Adjust the duration of the content expand transition.
   * Passed as a prop to the transition component.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration?: TransitionProps['timeout'] | 'auto'
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps?: TransitionProps
}

export const StepContent = React.forwardRef<HTMLDivElement, StepContentProps>(
  (props, ref) => {
    const {
      children,
      className,
      TransitionComponent = Collapse,
      transitionDuration: transitionDurationProp = 'auto',
      // TransitionProps,
      classes,
      sx,
      ...other
    } = props

    const { orientation } = useStepperContext() as StepperContextType
    const { active, last, expanded } = useStepContext() as StepContextType

    if (process.env.NODE_ENV !== 'production') {
      if (orientation !== 'vertical') {
        console.error(
          '<StepContent /> is only designed for use with the vertical stepper.'
        )
      }
    }
    // let transitionDuration = transitionDurationProp

    if (
      transitionDurationProp === 'auto' &&
      // @ts-ignore
      !TransitionComponent.factorSupportAuto
    ) {
      // @ts-ignore
      transitionDuration = undefined
    }

    return (
      <div
        ref={ref}
        className={clsx(
          classes?.root,
          style.root,
          last && [style.last, classes?.last],
          className,
          sxFunc(sx)
        )}
        {...other}
      >
        {/* <TransitionComponent
          in={active || expanded}
          className={classes?.transition}
          timeout={transitionDuration}
          unmountOnExit
          {...TransitionProps}
        > */}
        {/* @ts-ignore */}
        {(active || expanded) && children}
        {/* </TransitionComponent> */}
      </div>
    )
  }
)

StepContent.displayName = 'StepContent'
